import * as React from "react";
import { useEffect, useState } from "react";
import { lingvoUtility } from "../../EasyProjectsCommon/LingvoUtility";
import { commonClientResx } from "../../resxDist/commonClientResx";
import { ButtonProps } from "./Button";

export interface DisableTimerButtonProps {
    disableDelay: number;
}

type WrappedBtnProps = ButtonProps & DisableTimerButtonProps;

type WithDisableTimerButton = (Button: React.ComponentType<ButtonProps>) => React.FC<WrappedBtnProps>;
export const WithDisableTimerButton: WithDisableTimerButton =
    Button =>
    ({ disableDelay: initDisableDelay, ...props }) => {
        const [disableDelay, setDisableDelay] = useState(0);
        const [minWidth, setMinWidth] = useState(null as string);
        const isBtnDisabled = disableDelay > 0;

        useEffect(() => {
            // set initial disableDelay here in order to render btn with real text from props first time
            // to capture btn width with real text at onButtonRendered callback
            setDisableDelay(initDisableDelay);
        }, []);

        useEffect(() => {
            if (disableDelay > 0) {
                const timerId = setTimeout(() => {
                    setDisableDelay(delay => delay - 1);
                }, 1000);

                return () => clearTimeout(timerId);
            }
        }, [disableDelay]);

        const btnText = isBtnDisabled ? lingvoUtility.plural(disableDelay, commonClientResx.timer_text) : props.text;

        const onButtonRendered: F1<React.RefObject<HTMLSpanElement>, void> = ref => {
            // prevent button width increasing when delay is occurred (text changed from "1 second" -> "Delete permanently")
            // because otherwise user might click "delete" instead of "cancel" button.
            const currentStyle = window.getComputedStyle(ref.current);
            setMinWidth(currentStyle.width);

            props.refCallback?.(ref);
        };

        return (
            <Button
                {...props}
                style={{ minWidth }}
                text={btnText}
                disabled={isBtnDisabled}
                refCallback={onButtonRendered}
            />
        );
    };
